import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { RuleDot } from './Decor';
import { faqs } from '../data/faqs';
import { SECTION_IDS } from '../utils/scroll';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <section id={SECTION_IDS.preguntas} aria-labelledby="faq-titulo" className="scroll-mt-24 bg-ivory sm:scroll-mt-28" data-id="element-15" data-mp="1ge0jz00mfije">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16 lg:py-24" data-id="element-16" data-mp="291d3107kp87y">
        <div className="grid gap-7 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-20" data-id="element-17" data-mp="28za7y1rkcowd">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-18" data-mp="244cwypaq45gu">
            <RuleDot data-id="element-19" data-mp="1z2dstd75t4iu" />
            <h2 id="faq-titulo" className="mt-5 font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.5rem]" data-id="element-20" data-mp="1z2xdh1o7270k">
              Antes de comenzar, quizás te estés preguntando…
            </h2>
          </div>

          <div className="divide-y divide-lavender-200/80 border-y border-lavender-200/80" data-id="element-21" data-mp="pizf3w92p2fb">
            {faqs.map(faq => {
            const isOpen = openId === faq.id;
            return <div key={faq.id} className={`transition-colors duration-200 ease-premium ${isOpen ? 'bg-lavender-50/70' : 'hover:bg-lavender-50/50'}`} data-id="element-22" data-mp="fiqg6anp52w8">
                  <h3 data-id="element-23" data-mp="6plou4gb1k61">
                    <button type="button" onClick={() => setOpenId(isOpen ? null : faq.id)} aria-expanded={isOpen} aria-controls={`faq-panel-${faq.id}`} className="flex w-full items-start justify-between gap-6 px-3 py-5 text-left sm:px-5 sm:py-6" data-id="element-24" data-mp="biolilgdp9qg">
                      <span className={`text-[1rem] font-medium transition-colors duration-200 ease-premium sm:text-[1.0625rem] ${isOpen ? 'text-plum-900' : 'text-plum-800'}`} data-id="element-25" data-mp="3nzk3lns3n9cn">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-pill border transition-[background-color,border-color,transform] duration-200 ease-premium ${isOpen ? 'rotate-[135deg] border-plum-700 bg-plum-700 text-ivory' : 'border-lavender-200 bg-ivory text-plum-700'}`} data-id="element-26" data-mp="1ks2y7y6lq9ke">
                        <PlusIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-27" data-mp="1zfedaa1zsbp9" />
                      </span>
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-28" data-mp="o094cob9pgx7">
                    {isOpen && <motion.div id={`faq-panel-${faq.id}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.26,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-29" data-mp="2zoe1kejyfgbh">
                        <p className="max-w-2xl px-3 pb-6 pr-10 text-[0.975rem] leading-relaxed text-muted sm:px-5 sm:pb-7" data-id="element-30" data-mp="3idkaj9uy4tk3">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}